import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { modalActions } from '../../../redux/root-action';
import ReactModalHeader from '../../Modal/ReactModalHeader';
import ReactModalContent from '../../Modal/ReactModalContent';
import { modals } from '../../../utils/constants';

const YodleeIFrame = styled.div`
  padding-top: 48px;
`;

const thirdPartyScript = '/etc.clientlibs/workplace-fdi/components/content/yodlee-third-party-modal/clientlibs.js';
const removeThirdPartyScript = () => {
  const scripts = document.getElementsByTagName('script');
  for (let i = 0; i < scripts.length; i++) {
    if (scripts[i].src.indexOf(thirdPartyScript) > -1) {
      const el = scripts[i];
      el.parentNode?.removeChild(el);
    }
  }
};

class YodleeThirdParty extends Component<any> {
  props: any;
  state: any;
  constructor(props: any) {
    super(props);
    this.state = { content: undefined };
  }

  handleCloseIconClick = () => {
    const { hideModal } = this.props;
    removeThirdPartyScript();
    hideModal(modals.YODLEE_THIRD_PARTY);
  };

  async componentDidMount() {
    const { hideModal, showModal } = this.props;
    const w = window as any;
    const response = await fetch(
      '/content/workplace/en/participant/authors/Modals/sub-navigation/accounts/yodlee-third-party.html',
    );
    const script = document.createElement('script');
    script.src = thirdPartyScript;
    script.async = true;
    document.body.appendChild(script);
    const data = await response.text();
    this.setState({ content: data });

    const agreeButton = document.getElementById('consent-btn');
    const cancelButton = document.getElementById('cancel-btn');
    if (agreeButton) {
      agreeButton.addEventListener('click', function() {
        w.yodleeThirdPartyModal.saveYodleeConsent();
        showModal(modals.YODLEE_IFRAME);
      });
    }

    if (cancelButton) {
      cancelButton.addEventListener('click', function() {
        removeThirdPartyScript();
        hideModal(modals.YODLEE_THIRD_PARTY);
      });
    }
  }

  render() {
    const { content } = this.state;
    return (
      <React.Fragment>
        <ReactModalHeader showClose={true} handleCloseIconClick={this.handleCloseIconClick} />
        <ReactModalContent>
          <YodleeIFrame dangerouslySetInnerHTML={{ __html: content }} />
        </ReactModalContent>
      </React.Fragment>
    );
  }
}

export default connect(null, {
  showModal: modalActions.showModal,
  hideModal: modalActions.hideModal,
})(YodleeThirdParty);
